<template>
  <v-ons-list-item modifier="nodivider perfcours" :expandable="!!infosReste" :expanded.sync="isExpanded">
    <div class="center">
      Quantité
    </div>
    <div class="right">
      {{ venteTonne.toLocaleString('fr', { minimumFractionDigits: 3 }) }} t
      <span v-if="infosReste" class="list-item__expand-chevron"></span>
    </div>
    <div v-if="infosReste" class="expandable-content">
      <v-ons-list modifier="noborder nopadding">
        <v-ons-list-item v-if="infosReste.ral != undefined" modifier="perfcours perfsub">
          <div class="center">
            <div>
              {{ tonne_livre.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t livrées
            </div>
            <div>
              {{ reste_livre.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t à livrer
            </div>
            <v-ons-progress-bar :value="100 * (tonne_livre) / (tonne_livre + reste_livre)"></v-ons-progress-bar>
          </div>
        </v-ons-list-item>
        <v-ons-list-item v-if="infosReste.raf != undefined" modifier="perfcours perfsub">
          <div>
            {{ tonne_fixe.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t fixées
          </div>
          <div>
            {{ reste_fixe.toLocaleString('fr', { minimumFractionDigits: 3 }) }}&nbsp;t à fixer
          </div>
          <v-ons-progress-bar :value="100 * (tonne_fixe) / (tonne_fixe + reste_fixe)"></v-ons-progress-bar>
        </v-ons-list-item>
      </v-ons-list>
    </div>
  </v-ons-list-item>
</template>

<script>
export default {
  props: ['venteTonne', 'infosReste'],
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    tonne_livre() {
      return Math.max(this.venteTonne - this.infosReste.ral, 0);
    },
    reste_livre() {
      return Math.max(this.infosReste.ral, 0);
    },
    tonne_fixe() {
      return Math.max(this.venteTonne - this.infosReste.ral - this.infosReste.raf, 0);
    },
    reste_fixe() {
      return Math.max(this.infosReste.raf, 0);
    },
  },
  mounted() {
    if(this.infosReste){
      this.isExpanded = true;
    }
  }
}
</script>

<style>
.list-item--perfsub__center div {
  display: flex;
  padding-right: 6px;
  color: var(--perfarmer-gris-dark);
}
.list-item--perfsub__center div:first-child {
  color: #000;
  margin-right: auto;
  font-weight: 500;
}
.list-item--perfsub__center ons-progress-bar {
  display: flex;
  width: 100%;
  padding: 12px 6px 6px 0;
}
.list-item--perfsub__center .progress-bar {
  height: 10px;
  background-color: var(--perfarmer-gris-light);
}
</style>